/**
 * 10.可复用叙述型要点列表，展示标题和描述。 Figma：81033:19297
 */

import type { Highlight } from "./type";
import { ManagementBulletIcon } from "../StructuredCards/ManagementCallStructuredCard";

export interface AssetNarrativeHighlightsListProps {
  items: Highlight[];
}

export const AssetNarrativeHighlightsList: React.FC<
  AssetNarrativeHighlightsListProps
> = ({ items }) => {
  return (
    <div className="flex flex-col gap-3 rounded-2 bg-background_white_overlay5 px-2 py-3">
      {items.map((block, i) => (
        <div key={i} className="flex flex-col gap-1">
          <div className="flex items-center gap-1">
            <div className="relative size-2 shrink-0" aria-hidden>
              <ManagementBulletIcon />
            </div>
            <p className="body_medium_m text-content_primary">{block.title}</p>
          </div>
          <p className="body_m pl-3 text-content_tertiary">
            {block.description}
          </p>
        </div>
      ))}
    </div>
  );
};
